import React, { useState } from "react";
import "./TnsOperation.css";

function TnsOperation({ operationsData = [] }) {
  const [expanded, setExpanded] = useState({});

  const toggleExpanded = (index) => {
    setExpanded((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <section className="section-padding tnsoperation-section">
      <div className="tns-pattern-left"></div>

      {operationsData.map((item, index) => (
        <div
          key={item.id}
          className={`row align-items-center tnsoperation-row ${
            index % 2 !== 0 ? "flex-row-reverse" : ""
          }`}
        >
          {/* Mobile Heading */}
          <div className="col-12 mobile-heading">
            <h2 className="heading-title">
              {item.title}
              <span className="title-blue">{item.highlight}</span>
            </h2>
          </div>

          {/* Image */}
          <div className="col-lg-5 col-md-12 mb-4 mb-lg-0">
            <div className="tnsoperation-image-wrapper">
              <img
                src={item.image}
                alt={item.title}
                className="img-fluid rounded shadow-sm tnsoperation-image"
              />
            </div>
          </div>

          {/* Content */}
          <div className="col-lg-6 col-md-12">
            <div className="tnsoperation-content">

              {/* Desktop Heading */}
              <h2 className="heading-title text-start desktop-heading">
                {item.title}
                <span className="title-blue">{item.highlight}</span>
              </h2>

              <div
                className={`mobile-content ${
                  expanded[index] ? "expanded" : "collapsed"
                }`}
              >
                {item.paragraphs?.map((text, i) => {
                  const isLastParagraph =
                    i === item.paragraphs.length - 1;

                  return (
                    <p
                      key={i}
                      className={`sub-text sub-text2 ${
                        isLastParagraph ? "last-paragraph" : ""
                      }`}
                    >
                      {text}

                      {/* Read Less at the exact end of text */}
                      {isLastParagraph && expanded[index] && (
                        <button
                          type="button"
                          className="read-less-btn"
                          onClick={() => toggleExpanded(index)}
                        >
                          Read Less
                        </button>
                      )}
                    </p>
                  );
                })}

                {/* Read More */}
                {!expanded[index] && (
                  <button
                    type="button"
                    className="read-more-btn"
                    onClick={() => toggleExpanded(index)}
                  >
                    ...Read More
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}

export default TnsOperation;